import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const CreditCard = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24">
    <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M2.5 10h19" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

export default CreditCard;
